import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { NavMainMenuPage } from '../../../nav/nav-menus/nav-main-menu/nav-main-menu';
import { NavController } from 'ionic-angular';
import { NavHelperService } from '../../../../services/nav/nav-helper.service';
import { ImplementerService } from '../../../../services/implementer/implementer.service';
import { AppConfig } from '../../../../app/app.config';
import { DateTime } from 'luxon';

@Component({
  selector: 'implementer-merge-wizard-step-one',
  templateUrl: 'implementer-merge-wizard-step-one.html'
})
export class ImplementerMergeWizardStepOneComponent {
  @Input() snapshotSummary: ImplementerSnapshotSummary;

  @Output()
  public clickNextStep: EventEmitter<void> = new EventEmitter();

  config = AppConfig.settings;

  text: string;
  alternateSnapshotSummary: ImplementerSnapshotSummary;
  loading: boolean;
  connectionFailed: boolean;

  constructor(
    private navCtrl: NavController,
    private navHelperService: NavHelperService,
    private implementerService: ImplementerService,
  ) {
    this.loading = true;
  }

  async ngOnInit() {
    await this.checkAlternateEnvironmentSnapshot();
  }

  async checkAlternateEnvironmentSnapshot() {
    this.loading = true;
    const timeStart = DateTime.local();
    await this.implementerService.getAlternateSnapshotDirectly(this.config.isVesselEnvironment)
      .then(result => {
        this.alternateSnapshotSummary = result;
      })
      .catch(error => {
        this.connectionFailed = true;
    });

    // if api call returns faster than 3 seconds, setTimeout to wait until 3 seconds, minus what the api call took
    // so the user can actually see what's happening and it doesn't just flash up and disappear
    if ((DateTime.local().toMillis() - timeStart.toMillis()) / 1000 < 3) {
      setTimeout(() => {
        this.loading = false;
      }, 3000 - (DateTime.local().toMillis() - timeStart.toMillis()));
    } else {
      this.loading = false;
    }
  }

  nextStepClick() {
    this.clickNextStep.emit();
  }

  goBackClick() {
    this.navCtrl.pop();
    this.navHelperService.updateNavMenuPage({page: NavMainMenuPage});
  }
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-merge/implementer-merge-wizard-step-one/implementer-merge-wizard-step-one.ts